import { render, staticRenderFns } from "./DesignsFilters.vue?vue&type=template&id=39a7dd90&"
import script from "./DesignsFilters.vue?vue&type=script&lang=js&"
export * from "./DesignsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports